import { isUuid } from '@/shared/lib/entity'

export function assistantPath(page: string, entityId: string | null, targetId: string | null) {
  const normalizedPage = page.trim().toLowerCase()
  if (normalizedPage === 'home') return '/'
  if (!entityId || !isUuid(entityId)) return null
  const routes: Record<string, string> = {
    dashboard: 'dashboard',
    settings: 'settings',
    admin: 'settings',
    policies: 'settings/policies',
    policy: 'settings/policies',
    'printer policies': 'assets/configuration/printer-policies',
    whitelabel: 'settings/whitelabel',
    'custom domain': 'settings/custom-domain',
    'custom domains': 'settings/custom-domain',
    integrations: 'settings/integrations',
    'api connections': 'settings/integrations/api-connections',
    access: 'users',
    'access page': 'users',
    pending: 'pending-users',
    'pending page under access': 'pending-users',
    users: 'users',
    roles: 'roles',
    groups: 'groups',
    hierarchy: 'hierarchy',
    agents: 'agents',
    'agents overview': 'agents/overview',
    docs: 'docs',
    content: 'content',
    audit: 'audit-log',
    invitations: 'invitations',
  }
  if (targetId && isUuid(targetId)) {
    if (normalizedPage === 'user') return `/${entityId}/users/${targetId}`
    if (normalizedPage === 'role') return `/${entityId}/roles/${targetId}`
    if (normalizedPage === 'group') return `/${entityId}/groups/${targetId}`
  }
  return Object.hasOwn(routes, normalizedPage) ? `/${entityId}/${routes[normalizedPage]}` : null
}
